<app-workspace-master-detail [detailOpen]="detailOpen">
  <app-crm-cases workspace-master></app-crm-cases>
  <div workspace-detail class="workspace-page--full">
    <router-outlet></router-outlet>
  </div>
</app-workspace-master-detail>
